import { ToastActionKind, ToastConfig, ToastSeverity } from './toast.models';

export const TOAST_MAX_VISIBLE = 3;
export const TOAST_DURATION_SUCCESS_MS = 5000;
export const TOAST_DURATION_UNDO_MS = 8000;

export function resolveToastDuration(config: Pick<ToastConfig, 'durationMs' | 'severity' | 'action'>): number | null {
  if (config.durationMs !== undefined) {
    return config.durationMs;
  }
  if (config.action && config.action.kind === ToastActionKind.Undo) {
    return TOAST_DURATION_UNDO_MS;
  }
  if (config.severity === ToastSeverity.Warning || config.severity === ToastSeverity.Danger) {
    return null;
  }
  return TOAST_DURATION_SUCCESS_MS;
}

export function visibleToastSlice<T>(items: T[]): { visible: T[]; overflowCount: number } {
  if (items.length <= TOAST_MAX_VISIBLE) {
    return { visible: items, overflowCount: 0 };
  }
  return {
    visible: items.slice(0, TOAST_MAX_VISIBLE),
    overflowCount: items.length - TOAST_MAX_VISIBLE,
  };
}

/**
 * Focus in a field (native or Material: mat-select renders a div with role=combobox) keeps Ctrl+Z for the
 * field's own undo. Buttons, links and dialogs have no native Ctrl+Z, so it undoes the stage change there.
 */
const INTERACTIVE_KEYBOARD_TARGET = [
  'input', 'textarea', 'select', '[contenteditable]:not([contenteditable="false"])',
  '[role="combobox"]', '[role="listbox"]', '[role="option"]', '[role="textbox"]', '[role="spinbutton"]',
  '[role="menu"]', '[role="menuitem"]', 'mat-select',
].join(', ');

export function isEditableKeyboardTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  return target.isContentEditable || !!target.closest(INTERACTIVE_KEYBOARD_TARGET);
}

export function isUndoKeyboardEvent(event: KeyboardEvent): boolean {
  if (event.altKey || event.shiftKey) {
    return false;
  }
  if (!event.metaKey && !event.ctrlKey) {
    return false;
  }
  return event.key === 'z' || event.key === 'Z';
}
